import { render } from "./BusinessInfo_detail.vue?vue&type=template&id=42b1a044&scoped=true"
import script from "./BusinessInfo_detail.vue?vue&type=script&lang=js"
export * from "./BusinessInfo_detail.vue?vue&type=script&lang=js"

import "./BusinessInfo_detail.vue?vue&type=style&index=0&id=42b1a044&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b1a044"]])

export default __exports__